import * as React from 'react';
import { useEffect, useState } from 'react';

import { REQUEST_SUCCESS } from '@/config/appConstants';
import { useAuth } from '@/lib/auth';

import { SpinnerContainer } from '../SpinnerContainer';

type responseStatus = typeof REQUEST_SUCCESS;
export const LoginContainer = () => {
  const { login } = useAuth();
  const [isLogged, setIsLogged] = useState(false);

  useEffect(() => {
    if (!isLogged) {
      login((status: responseStatus) => {
        if (status === REQUEST_SUCCESS) {
          setIsLogged(true);
        }
      });
    }
  });

  if (isLogged) {
    window.location.assign(window.location.pathname);
    return <></>;
  }
  return <SpinnerContainer />;
};
